import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import Navigate from "./navigate"
import { css } from "@emotion/core"
import "react-sticky-header/styles.css"
import StickyHeader from "react-sticky-header"

const Header = () => {
  //Query logo
  const { logo } = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "CORM.png" }) {
        publicURL
      }
    }
  `)

  return (
    <StickyHeader
      header={
        <header
          css={css`
            background-color: #18069c;
            padding: 1rem;
          `}
        >
          <div
            css={css`
              max-width: 120rem;
              margin: 0 auto;
              text-align: center;

              @media (min-width: 768px) {
                display: flex;
                align-items: center;
                justify-content: space-between;
              }
            `}
          >
            <Link>
              <img
                src={logo.publicURL}
                alt="Logo Ofaris"
                width="160"
                css={css`
                  vertical-align: middle;
                `}
              />
            </Link>

            <Navigate />
          </div>
        </header>
      }
    ></StickyHeader>
  )
}

export default Header
